import moment from "moment-timezone";
export const getCalendarSeats = ({
  userStartTime,
  userEndTime,
  timeZone,
  seats = [],
  bookings,
  exceptions,
  listingSeats
}) => {
  const intervalsPerDay = 96;
  const intervalMinutes = 15;

  const userMomentLocal = moment.tz(userStartTime, timeZone);
  const localStartDay = userMomentLocal.clone().startOf("day");
  const utcStartDay = localStartDay.clone().utc();

  let durationCount;
  if (userEndTime) {
    const userEndLocal = moment.tz(userEndTime, timeZone).startOf("day");
    durationCount = userEndLocal.diff(localStartDay, "days") + 1;
    if (durationCount <= 0) {
      return {
        arrayStartUTC: utcStartDay.toISOString(),
        results: [],
      };
    }
  } else {
    durationCount = 60;
  }

  const userMomentUTC = moment.tz(userStartTime, timeZone).clone().utc();

  const todayUTC = moment.utc().startOf("day");
  const arrayStartUTC = todayUTC.clone().subtract(1, "day");

  const diffInMinutes = userMomentUTC.diff(arrayStartUTC, "minutes");
  const startIndex = Math.floor(diffInMinutes / intervalMinutes);

  const totalIntervals = seats?.length;
  const results = [];
  for (let day = 0; day < durationCount; day++) {
    const currentStartIndex = startIndex + day * intervalsPerDay;
    const endIndex = currentStartIndex + intervalsPerDay;

    if (currentStartIndex < 0 || endIndex > totalIntervals) {
      results.push({
        date: moment
          .utc(arrayStartUTC)
          .add(currentStartIndex * intervalMinutes, "minutes")
          .format("YYYY-MM-DD"),
        error: "Out of range",
        minSeats: null,
      });
      continue;
    }

    const daySeats = seats.slice(currentStartIndex, endIndex);
    const bookingsSlots = bookings.slice(currentStartIndex, endIndex);

    const hasBookingsSlot = bookingsSlots.some((slot) => slot);
    const minSeats = Math.min(...daySeats);
    const exceptionSeats = exceptions?.find(
      (item) =>
        item.date ===
        moment
          .utc(arrayStartUTC)
          .add(currentStartIndex * intervalMinutes, "minutes")
          .format("YYYY-MM-DD"))


    results.push({
      date: moment
        .utc(arrayStartUTC)
        .add(currentStartIndex * intervalMinutes, "minutes")
        .format("YYYY-MM-DD"),
      minSeats,
      booked: hasBookingsSlot,
      exception: exceptionSeats ? true : false,
      totalBookings: exceptionSeats ? exceptionSeats?.seats - minSeats : listingSeats - minSeats,
    });
  }
  return results;
};